/** @module polyfills */

/**
 * Ensures support for Intersection Observer API
 * @see https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver
 */
export function intersectionObserver() {
    // use pseudo-dynamic import to make package free from side-effects
    import(/* webpackMode: "eager" */ 'intersection-observer');
}
